<template>
  <div id="vehicle_create" class="fleet-form-main">
      <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <div id="page-content-wrapper" class="admin-content-area">
            <div class="page-name">
                <span class="page-title" id="vehicleHeader">Update Timelog</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="Back" >
                    <i class="fp-back"> </i> Back
                </button>
            </div>
            <template v-if="cantAccessPage === true">
                <div class="container-fluid">
                    <div class="admin-page-content timelog-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal form-custom-select basic-form-container" id="TransportingRequestForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div v-if="user_name != ''" class="col form-groups">
                                        <label class="control-label require" for="user_name">User:</label>
                                        <input type="text" class="form-control" v-model="user_name" id="user_name"
                                        placeholder="Enter User" name="requested_by" disabled>
                                    </div>    
                                    <div v-if="inderect_code != null" class="col form-groups">
                                        <label :class="indirect_cd_class" for="requested_by">Inderect Labor Code:</label>
                                        <input type="text" class="form-control" v-model="inderect_code" id="requested_by"
                                        placeholder="Enter Inderect Labor Code" name="requested_by" disabled>
                                        <div class="field-error">{{inderect_code_err_msg}}</div>
                                    </div>
                                    <div v-if="work_order != null" class="col form-groups">
                                        <label :class="wo_no_class" for="requested_by">Work Order:</label>
                                        <input type="text" class="form-control" v-model="work_order" id="requested_by"
                                        placeholder="Work Order" name="requested_by" disabled>
                                        <div class="field-error">{{work_order_err_msg}}</div>
                                    </div>
                                    <div v-if="vmrs_code != null" class="col form-groups">
                                        <label class="control-label require" for="requested_by">VMRS Code:</label>
                                        <input type="text" class="form-control" v-model="vmrs_code" id="requested_by"
                                        placeholder="Enter VMRS Code" name="requested_by" disabled>
                                        <div class="field-error">{{vmrs_code_err_msg}}</div>
                                    </div>
                                    <div v-if="task != null" class="col form-groups">
                                        <label class="control-label require" for="requested_by">Task:</label>
                                        <input type="text" class="form-control" v-model="task" id="requested_by" placeholder="Enter Task" name="requested_by" disabled>
                                        <div class="field-error">{{task_err_msg}}</div>
                                    </div>
                                    <div class="col form-groups">
                                        <label class="control-label require" for="requested_by">Start Time:</label>
                                        <input type="text" class="form-control" v-model="start_time" id="requested_by"
                                        placeholder="Enter Start Time" name="requested_by" disabled>
                                        <div class="field-error">{{start_time_err_msg}}</div>
                                    </div>
                                    <div class="col form-groups">
                                        <label class="control-label require" for="requested_by">End Time:</label>
                                        <input type="text" class="form-control" v-model="end_time" id="requested_by" placeholder="Enter End Time" name="requested_by" disabled>
                                        <div class="field-error">{{end_time_err_msg}}</div>
                                    </div>
                                    <div class="col form-groups">
                                        <label class="control-label require" for="requested_by">Duration:</label>
                                        <input type="text" class="form-control" v-model="duration" id="requested_by"
                                        placeholder="Enter Duration" name="requested_by" disabled>
                                        <div class="field-error">{{duration_err_msg}}</div>
                                    </div>
                                    <div class="col form-groups">
                                        <label class="control-label require" for="requested_by">Update Duration:</label>
                                        <input type="text" v-cleave="{time: true,timePattern: ['h','m']}" class="form-control" v-model="update_duration" @keyup="validateTime($event)" id="update_duration" placeholder="HH:MM" name="update_duration">
                                        <!-- <input-mask id="update_duration" :alwaysShowMask="true" name="update_duration" v-model="update_duration" :mask="timeMask"
                                            :format-chars="timeMaskOptions.formatChars"
                                            :always-show-mask="timeMaskOptions.alwaysShowMask" class="form-control">
                                        </input-mask> -->
                                        <div class="field-error">{{update_duration_err_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createBtn" class="btn btn-primary" v-on:click.prevent="UpdateLog" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="cancelBtn" class="btn btn-tertiary" v-on:click.prevent="Back" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>  
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>  
      </div>
  </div>
</template>

<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

// import InputMask from 'vue-input-mask';
// Vue.component('input-mask', InputMask);
var self;

export default {
   name: "EditTimeLog",
   metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Update Timelog | " +process.env.COPYRIGHT_NAME
   },
   
    mixins: [commonMixins, contractMixins],
    data: () => ({
      userId: 0,
      timeLogId : 0,
      loading:false,
      work_order: '',
      work_order_err_msg: '',
      vmrs_code: '',
      vmrs_code_err_msg: '',
      task: '',
      task_err_msg: '',
      start_time: '',
      start_time_err_msg: '',
      end_time: '',
      end_time_err_msg: '',
      duration: '',
      duration_err_msg: '',
      inderect_code: '',
      inderect_code_err_msg: '',
      update_duration: '',
      update_duration_err_msg: '',
      optionsDate: {
          format: 'HH:mm:ss',
          useCurrent: false,
      },
      permissions:[],
      cantAccessPage:"",
      old_update_duration:0,
      user_name:"",
      indirect_cd_class:"control-label",
      wo_no_class:"control-label"  
    }),
    watch:{

        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'etk_add') {
                    self.cantAccessPage = true;
                }
            });
        },
    },
    beforeMount() {
      self = this;
    },
    computed: {
        timeMask () {
            if (!this.update_duration || this.update_duration === '' || this.update_duration[0] === '2') {
                return '23:59';
            }
            return '29:59';
        },
        timeMaskOptions () {
            return { formatChars: { '2': '[0-2]', '3': '[0-3]', '5': '[0-5]', '9': '[0-9]' }, alwaysShowMask: false }
        }
    },
    mounted: function() {

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
          console.log(userObj.first_name);
          self.userId = userObj.id;
        }

        // var d = new Date();

        // self.update_duration = d;
        this.getPermissions();    
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
          self.timeLogId = segments[3];
          self.getLogDetail();
        }

        console.log(self.timeLogId);


    },
    methods: {
      UpdateLog: function() {
          var error = false;
          self.update_duration_err_msg = "";

          if (!self.update_duration || self.update_duration == 0 || self.update_duration == "") {
              self.update_duration_err_msg = "Update Duration Required.";
              error = true;
          }else{
            if ( self.update_duration.indexOf("_") > -1 ) {
                self.update_duration_err_msg = "Please check Updated Duration format.";
                error = true;
            }
          }

        if(!error) {    

          console.log(self.update_duration);
          self.loading = true;
          $.ajax({
              url: process.env.ROOT_API + '/update-timelog-byid',
              type: "POST",
              crossDomain: true,
              dataType: "json",
              headers: this.ajxHeaders,
              data:{
                id: self.timeLogId,
                update_time: self.update_duration,
                user_id: self.userId,
              },

              success: function(data) {
                self.loading = false;    
                if (data.status == "success") {

                  self.Back();

                }


              },
              error: function(jqXHR, exception) {
                  self.loading = false;
                console.log("data == ", jqXHR);
                  self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
              }
          });


        }

      },
      Back: function () {
        var self = this;
        self.$router.push('/work-entry/time');
      },
      getLogDetail: function() {
        var self = this;
        self.loading = true;  
        $.ajax({
            url: process.env.ROOT_API + "/get-timelog-byid?id=" + self.timeLogId,
            type: "GET",
            crossDomain: true,
            dataType: "json",
            headers: this.ajxHeaders,
            data:{},

            success: function(data) {
              console.log("res == ",data);
              self.loading = false;
              if(data.status == 'success') {
                if (data.content.work_no != undefined && data.content.work_no != null && data.content.work_no != "") {
                    self.wo_no_class = "control-label require";
                    self.work_order = data.content.work_no + " | " + data.content.line_number;
                    if (data.content.unit_no != undefined && data.content.unit_no != null) {
                        self.work_order = data.content.work_no + " | " + data.content.line_number +" | "+data.content.unit_no;
                    }
                }
                self.vmrs_code = data.content.component;
                self.task = data.content.task;
                self.start_time = data.content.start_time;
                self.end_time = data.content.end_time;
                self.duration = data.content.duration;
                if (data.content.inderect_code != undefined && data.content.inderect_code != null && data.content.inderect_code != "") {
                    self.indirect_cd_class = "control-label require";
                    self.inderect_code = data.content.inderect_code;
                }
                self.update_duration = data.content.decimal_duration;
                self.old_update_duration = data.content.updated_duration;
                if (data.content.user_name != undefined && data.content.user_name != null && data.content.user_name != "") {
                    self.user_name = data.content.user_name;
                }
              }

            },
            error: function(jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
            }
        });
      }

    }

}
</script>





// WEBPACK FOOTER //
// src/components/WorkEntry/EditTimeLog.vue